import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './full-size-container.css';
import facesLogo from '../../assets/faces-partial.png';

// Placeholder for custom logo; replace with prop or context as needed
const customLogo = localStorage.getItem('facesLogoUrl');

function FullSizeContainer({ title, children, prevURL }) {
  const navigate = useNavigate();
  return (
    <div className="full-size-root">
      <main className="full-size-content">
        <div className="full-size-header-block">
          <div className="header-row-wrapper">
            <div className="full-size-header-row">
              <div className="full-size-title-corner">
                <button
                  className="full-size-back-arrow"
                  onClick={() => navigate(prevURL ? prevURL : '/menu')}
                  aria-label="Back to menu"
                >
                  <FaArrowLeft size={28} color="#ba383d" />
                </button>
                {title && <span className="full-size-title-text">{title}</span>}
              </div>
              <div className="full-size-logos-corner">
                <img
                  src={facesLogo}
                  alt="FACES™ logo"
                  className="faces-header-logo"
                />
                {customLogo && (
                  <>
                    <div className="full-size-logos-vertical-separator" />
                    <img
                      src={customLogo}
                      alt="Custom logo"
                      className="custom-header-logo"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="full-size-horizontal-separator" />
        <div className="full-size-main-body">{children}</div>
      </main>
    </div>
  );
}

export default FullSizeContainer;
